import { createSlotRecipe } from './runtime.js';

const tableRowConfig = {"name":"tableRow","className":"table-row","slots":["root","bottomLine","dragHandle"],"defaultVariants":{"isActive":false,"isSelected":false,"showBottomLine":true,"state":"default"},"variantMap":{"isActive":["false","true"],"isSelected":["false","true"],"showBottomLine":["false","true"],"state":["default","dragging"]}}

export const tableRow = /* @__PURE__ */ createSlotRecipe(tableRowConfig)